const localidades = [
  ['Abayuba', 'Montevideo'],
  ['Aguada', 'Montevideo'],
  ['Aires Puros', 'Montevideo'],
  ['Atahualpa', 'Montevideo'],
  ['Bañados De Carrasco', 'Montevideo'],
  ['Barrio Sur', 'Montevideo'],
  ['Bella Italia', 'Montevideo'],
  ['Bella Vista', 'Montevideo'],
  ['Belvedere', 'Montevideo'],
  ['Bolivar', 'Montevideo'],
  ['Brazo Oriental', 'Montevideo'],
  ['Buceo', 'Montevideo'],
  ['Capurro', 'Montevideo'],
  ['Carrasco', 'Montevideo'],
  ['Carrasco Norte', 'Montevideo'],
  ['Casabo', 'Montevideo'],
  ['Casavalle', 'Montevideo'],
  ['Castellanos', 'Montevideo'],
  ['Castro', 'Montevideo'],
  ['Centro', 'Montevideo'],
  ['Cerrito', 'Montevideo'],
  ['Cerro', 'Montevideo'],
  ['Ciudad Vieja', 'Montevideo'],
  ['Colon Centro', 'Montevideo'],
  ['Colon Noroeste', 'Montevideo'],
  ['Colon Sureste', 'Montevideo'],
  ['Conciliacion', 'Montevideo'],
  ['Cordon', 'Montevideo'],
  ['Figurita', 'Montevideo'],
  ['Flor De Maroñas', 'Montevideo'],
  ['Ituzaingo', 'Montevideo'],
  ['Jacinto Vera', 'Montevideo'],
  ['Jardines Del Hipodromo', 'Montevideo'],
  ['La Blanqueada', 'Montevideo'],
  ['La Comercial', 'Montevideo'],
  ['La Paloma', 'Montevideo'],
  ['La Teja', 'Montevideo'],
  ['Larrañaga', 'Montevideo'],
  ['Las Acacias', 'Montevideo'],
  ['Las Canteras', 'Montevideo'],
  ['Lavalleja', 'Montevideo'],
  ['Lezica', 'Montevideo'],
  ['Malvin', 'Montevideo'],
  ['Malvin Norte', 'Montevideo'],
  ['Manga', 'Montevideo'],
  ['Manga Rural', 'Montevideo'],
  ['Maroñas', 'Montevideo'],
  ['Melilla', 'Montevideo'],
  ['Mercado Modelo', 'Montevideo'],
  ['Nueva Savona', 'Montevideo'],
  ['Nuevo Paris', 'Montevideo'],
  ['Pajas Blancas', 'Montevideo'],
  ['Palermo', 'Montevideo'],
  ['Parque Batlle', 'Montevideo'],
  ['Parque Guarani', 'Montevideo'],
  ['Parque Rodo', 'Montevideo'],
  ['Paso De La Arena', 'Montevideo'],
  ['Paso De Las Duranas', 'Montevideo'],
  ['Peñarol', 'Montevideo'],
  ['Piedras Blancas', 'Montevideo'],
  ['Pocitos', 'Montevideo'],
  ['Prado', 'Montevideo'],
  ['Pueblo Victoria', 'Montevideo'],
  ['Puerto', 'Montevideo'],
  ['Punta Carretas', 'Montevideo'],
  ['Punta Gorda', 'Montevideo'],
  ['Punta Rieles', 'Montevideo'],
  ['Reducto', 'Montevideo'],
  ['Retiro', 'Montevideo'],
  ['Santiago Vazquez', 'Montevideo'],
  ['Sayago', 'Montevideo'],
  ['Toledo Chico', 'Montevideo'],
  ['Tomkinson', 'Montevideo'],
  ['Tres Cruces', 'Montevideo'],
  ['Tres Ombues', 'Montevideo'],
  ['Union', 'Montevideo'],
  ['Villa Dolores', 'Montevideo'],
  ['Villa Española', 'Montevideo'],
  ['Villa Garcia', 'Montevideo'],
  ['Villa Muñoz', 'Montevideo'],
  ['Canelones', 'Canelones'],
  ['Las Piedras', 'Canelones'],
  ['Ciudad de la Costa', 'Canelones'],
  ['Salinas', 'Canelones'],
  ['Santa Lucia', 'Canelones'],
  ['Montes', 'Canelones'],
  ['San Jacinto', 'Canelones'],
  ['Los Cerrillos', 'Canelones'],
  ['Joaquin Suarez', 'Canelones'],
  ['Salinas Sur', 'Canelones'],
  ['Fortin de Santa Rosa', 'Canelones'],
  ['Parque del Plata', 'Canelones'],
  ['Bello Horizonte', 'Canelones'],
  ['La Tuna', 'Canelones'],
  ['Biarritz', 'Canelones'],
  ['San Ramon', 'Canelones'],
  ['San Antonio', 'Canelones'],
  ['Migues', 'Canelones'],
  ['Aguas Corrientes', 'Canelones'],
  ['Sauce', 'Canelones'],
  ['Empalme Olmos', 'Canelones'],
  ['Toledo', 'Canelones'],
  ['Atlantida', 'Canelones'],
  ['La Floresta', 'Canelones'],
  ['San Luis', 'Canelones'],
  // ['Araminda', 'Canelones'],
  ['Cuchilla Alta', 'Canelones'],
  ['Tala', 'Canelones'],
  ['San Bautista', 'Canelones'],
  ['Santa Rosa', 'Canelones'],
  ['Joanico', 'Canelones'],
  ['Progreso', 'Canelones'],
  ['Pando', 'Canelones'],
  ['Parque de Carrasco', 'Canelones'],
  ['Neptunia', 'Canelones'],
  ['Salinas Norte', 'Canelones'],
  ['Marindia', 'Canelones'],
  ['Las Toscas', 'Canelones'],
  ['Costa Azul', 'Canelones'],
  ['Los Titanes', 'Canelones'],
  ['Santa Lucia del Este', 'Canelones'],
  ['Santa Ana', 'Canelones'],
  ['Balneario Argentino', 'Canelones'],
  ['Balneario Solis', 'Canelones'],
  ['Capilla Cella', 'Canelones'],
  ['Costas del Pedernal', 'Canelones'],
  ['Canelon Chico', 'Canelones'],
  ['Melilla', 'Canelones'],
  ['Suarez', 'Canelones'],
  ['Paso del Pache', 'Canelones'],
  ['Pueblo Bolivar', 'Canelones'],
  ['Tapia', 'Canelones'],
  ['Carrasco del Sauce', 'Canelones'],
  ['Caserio Murialdo', 'Canelones'],
  ['Las Brujas', 'Canelones'],
  ['Los Aromos', 'Canelones'],
  ['Jaureguiberry', 'Canelones'],
  ['Vista Linda', 'Canelones'],
  ['Costa de Pando', 'Canelones'],
  ['Estacion Migues', 'Canelones'],
  ['La Paz', 'Canelones'],
  ['Barros Blancos', 'Canelones'],
  ['Totoral', 'Canelones'],
  ['Paso del Medio', 'Canelones'],
  ['Santa Teresita', 'Canelones'],
  ['La Querencia', 'Canelones'],
  ['Poquitos', 'Canelones'],
  ['Castellanos', 'Canelones'],
  ['Barra de Carrasco', 'Canelones'],
  ['Paso Carrasco', 'Canelones'],
  ['Aeropuerto', 'Canelones'],
  ['Camino Lloveras', 'Canelones'],
  ['Costa de Pantanoso', 'Canelones'],
  ['Estacion Pedrera', 'Canelones'],
  ['Piedras de Afilar', 'Canelones'],
  ['Cap. Juan A. Artigas', 'Canelones'],
  ['Paso de la Cadena', 'Canelones'],
  ['Piedra del Toro', 'Canelones'],
  ['Soca', 'Canelones'],
  ['Cruz de los Caminos', 'Canelones'],
  ['El Colorado', 'Canelones'],
  ['Estacion Atlantida', 'Canelones'],
  ['El Dorado', 'Canelones'],
  ['Toledo Chico', 'Canelones'],
  ['Pinamar', 'Canelones'],
  ['Lagomar', 'Canelones'],
  ['Colonia Nicolich', 'Canelones'],
  ['El Pinar', 'Canelones'],
  ['Shangrila', 'Canelones'],
  ['Lomas de Solymar', 'Canelones'],
  ['Araminda', 'Canelones'],
  ['Solymar', 'Canelones'],
  ['Solymar Norte', 'Canelones'],
  ['Solymar Sur', 'Canelones'],
  ['San José de Carrasco', 'Canelones'],
  ['Colinas de Solymar', 'Canelones'],
  ['Pinar Norte', 'Canelones'],
  ['MEDANOS DE SOLYMAR', 'Canelones'],
  ['MONTES DE SOLYMAR', 'Canelones'],
  ['SHANGRILA NORTE', 'Canelones'],
  ['PINARES DE SOLYMAR', 'Canelones'],
  ['Parque de Miramar', 'Canelones'],
  ['El Bosque', 'Canelones'],
  ['LAGOMAR NORTE', 'Canelones'],
  ['EMPALME NICOLICH', 'Canelones'],
  ['LAGOMAR SUR', 'Canelones'],
  ['SHANGRILA SUR', 'Canelones'],
  ['PARQUE SOLYMAR', 'Canelones'],
  ['PINAR SUR', 'Canelones'],
  ['Villa Argentina', 'Canelones'],
  ['Cassarino', 'Canelones'],
  ['Pinares del Este', 'Canelones'],
  ['Las Vegas', 'Canelones'],
  ['Aeroparque', 'Canelones'],
  ['Pinamar Sur', 'Canelones'],
  ['Cap.Juan A.Artigas', 'Canelones'],
  ['GUAZUVIRA', 'Canelones'],
  ['CAMPO MILITAR', 'Canelones'],
  ['CHAMIZO', 'Canelones'],
  ['COLONIA 33 ORIENTALE', 'Canelones'],
  ['ESTACION TAPIA', 'Canelones'],
  ['FRAY MARCOS', 'Canelones'],
  ['GUAZUVIRA NUEVO', 'Canelones'],
  ['LA ESCOBILLA', 'Canelones'],
  ['PARAJE SAN JUAN', 'Canelones'],
  ['PASO DEL BOTE', 'Canelones'],
  ['PINE PARK', 'Canelones'],
  ['VILLA DEL MAR', 'Canelones'],
  ['ING.ANDREONI', 'Canelones'],
  ['SAN FRANCISCO', 'Canelones'],
  ['SOLIS CHICO', 'Canelones'],
  ['BOLIVAR', 'Canelones'],
  ['REPRESA CAN.GDE', 'Canelones'],
  ['Maldonado', 'Maldonado'],
  ['Punta del Este', 'Maldonado'],
  ['Piriápolis', 'Maldonado'],
  ['Punta Ballena', 'Maldonado'],
  ['Aigua', 'Maldonado'],
  ['Izcua', 'Maldonado'],
  ['Nueva Carrara', 'Maldonado'],
  ['Balneario Solis', 'Maldonado'],
  ['Playa Verde', 'Maldonado'],
  ['Las Flores', 'Maldonado'],
  ['Las Delicisa', 'Maldonado'],
  ['Santa Monica', 'Maldonado'],
  ['La Barra', 'Maldonado'],
  ['Faro Jose Ignacio', 'Maldonado'],
  ['Las Cañas', 'Maldonado'],
  ['Gregorio Aznarez', 'Maldonado'],
  ['Punta Colorada', 'Maldonado'],
  ['Punta Solis', 'Maldonado'],
  ['San Rafael', 'Maldonado'],
  ['Bella Vista', 'Maldonado'],
  ['Portezuelo', 'Maldonado'],
  ['San Carlos', 'Maldonado'],
  ['Garzon', 'Maldonado'],
  ['Los Talas', 'Maldonado'],
  ['Balneario Las Flores', 'Maldonado'],
  ['Pan de Azucar', 'Maldonado'],
  ['Pueblo Eden', 'Maldonado'],
  ['Punta Fria', 'Maldonado'],
  ['Manantiales', 'Maldonado'],
  ['PLAYA HERMOSA', 'Maldonado'],
  ['SAUCE DE PORTEZUELO', 'Maldonado'],
  ['Rocha', 'Rocha'],
  ['Castillos', 'Rocha'],
  ['La Paloma', 'Rocha'],
  ['Diecinueve de Abril', 'Rocha'],
  ['Costa Azul', 'Rocha'],
  ['Los Indios', 'Rocha'],
  ['San Luis', 'Rocha'],
  ['Gral. Enrique Martin', 'Rocha'],
  ['San Luis al Medio', 'Rocha'],
  ['Punta Pelotas', 'Rocha'],
  ['Punta San Miguel', 'Rocha'],
  ['Punta de la Coronill', 'Rocha'],
  ['Punta del Barco', 'Rocha'],
  ['Punta Aguda', 'Rocha'],
  ['Aguas Dulces', 'Rocha'],
  ['Cebollati', 'Rocha'],
  ['Dieciocho de Julio', 'Rocha'],
  ['La Pedrera', 'Rocha'],
  ['Poblado 19 de Junio', 'Rocha'],
  ['Santa Teresa', 'Rocha'],
  ['Picada de Techera', 'Rocha'],
  ['Peralle', 'Rocha'],
  ['Punta San Luis', 'Rocha'],
  ['Barra del Chuy', 'Rocha'],
  ['Punta de la Moza', 'Rocha'],
  ['Angostura', 'Rocha'],
  ['Cabo Polonio', 'Rocha'],
  ['Barra de Valizas', 'Rocha'],
  ['Chuy', 'Rocha'],
  ['Lascano', 'Rocha'],
  ['Punta del Diablo', 'Rocha'],
  ['Velazquez', 'Rocha'],
  ['Los Talas', 'Rocha'],
  ['Punta Nagro', 'Rocha'],
  ['Punta de las Piedras', 'Rocha'],
  ['La Coronilla', 'Rocha'],
  ['Punta Cerro Chato', 'Rocha'],
  ['Punta Castillos', 'Rocha'],
  ['Cabo Santa Maria', 'Rocha'],
  ['ARACHANIA', 'Rocha'],
  ['LA AGUADA', 'Rocha'],
  ['PASO BARRANCAS', 'Rocha'],
  ['LA ESMERALDA', 'Rocha'],
  ['Minas', 'Lavalleja'],
  ['Nico Perez', 'Lavalleja'],
  ['Estacion Andreoni', 'Lavalleja'],
  ['La Coronilla', 'Lavalleja'],
  ['Ortiz', 'Lavalleja'],
  ['Polanco', 'Lavalleja'],
  ['Zapican', 'Lavalleja'],
  ['Barrancas', 'Lavalleja'],
  ['J. Batlle y Ordoñez', 'Lavalleja'],
  ['Aguas Blancas', 'Lavalleja'],
  ['Casupa', 'Lavalleja'],
  ['Solis', 'Lavalleja'],
  ['Mariscala', 'Lavalleja'],
  ['Pedro Aramendia', 'Lavalleja'],
  ['Solis Chico', 'Lavalleja'],
  ['Valle Fuentes', 'Lavalleja'],
  ['Ingeniero Andreoni', 'Lavalleja'],
  ['Est. Illescas', 'Lavalleja'],
  ['Batlle y Ordoñez', 'Lavalleja'],
  ['Colon', 'Lavalleja'],
  ['J. Pedro Varela', 'Lavalleja'],
  ['Marmaraja', 'Lavalleja'],
  ['Piraraja', 'Lavalleja'],
  ['Solis de Mataojo', 'Lavalleja'],
  ['Polanco Sur', 'Lavalleja'],
  ['Villa Serrana', 'Lavalleja'],
  ['Est. Montes', 'Lavalleja'],
  ['VELENTINES', 'Lavalleja'],
  ['Villa Rosario', 'Lavalleja'],
  ['Treinta y Tres', 'Treinta y Tres'],
  ['Cerros de Amarro', 'Treinta y Tres'],
  ['Julio Maria Sanz', 'Treinta y Tres'],
  ['Rincon', 'Treinta y Tres'],
  ['Vergara', 'Treinta y Tres'],
  ['Cañada Chica', 'Treinta y Tres'],
  ['Picada de Techera', 'Treinta y Tres'],
  ['Arrozal Treinta y Tr', 'Treinta y Tres'],
  ['Enrique Martinez', 'Treinta y Tres'],
  ['Maria Albina', 'Treinta y Tres'],
  ['Tupambae', 'Treinta y Tres'],
  ['Villa Pasano', 'Treinta y Tres'],
  ['Est. Aparicio Saravi', 'Treinta y Tres'],
  ['Cerro Chato', 'Treinta y Tres'],
  ['Isla Patrulla', 'Treinta y Tres'],
  ['Olimar', 'Treinta y Tres'],
  ['Valentines', 'Treinta y Tres'],
  ['Mendizabal', 'Treinta y Tres'],
  ['Placido Rosas', 'Treinta y Tres'],
  ['Durazno', 'Durazno'],
  ['Caballero', 'Durazno'],
  ['Cerro Chato', 'Durazno'],
  ['El Ceibal', 'Durazno'],
  ['Molles', 'Durazno'],
  ['Paraje El Chileno', 'Durazno'],
  ['San Jorge', 'Durazno'],
  ['Villasboas', 'Durazno'],
  ['Punta de Malbajar', 'Durazno'],
  ['Paso Real de Carpint', 'Durazno'],
  ['Santa Bernardina', 'Durazno'],
  ['Aguas Buenas', 'Durazno'],
  ['Carmen', 'Durazno'],
  ['Colonia Rossel y Riu', 'Durazno'],
  ['Feliciano', 'Durazno'],
  ['Ombues de Oribe', 'Durazno'],
  ['Parish', 'Durazno'],
  ['Sarandi del Yi', 'Durazno'],
  ['Cuchilla de Ramirez', 'Durazno'],
  ['Est. Ptas. de Herrer', 'Durazno'],
  ['Baygorria', 'Durazno'],
  ['Polanco del Yi', 'Durazno'],
  ['Blanquillo', 'Durazno'],
  ['Carpinteria', 'Durazno'],
  ['Cuadra', 'Durazno'],
  ['La Paloma', 'Durazno'],
  ['Palmar de Porrua', 'Durazno'],
  ['Pueblo Centenario', 'Durazno'],
  ['Tapes', 'Durazno'],
  ['Cerro Convento', 'Durazno'],
  ['Est. Elias Regules', 'Durazno'],
  ['Carlos Reyles', 'Durazno'],
  ['CENTENARIO', 'Durazno'],
  ['San José de Mayo', 'San José'],
  ['Libertad', 'San José'],
  ['Delta del Tigre', 'San José'],
  ['Kiyu', 'San José'],
  ['Colonia Agraria Delt', 'San José'],
  ['Chamizo', 'San José'],
  ['Ismael Cortinas', 'San José'],
  ['Mal Abrigo', 'San José'],
  ['Rincon de Albano', 'San José'],
  ['Rincon del Pino', 'San José'],
  ['Colonia America', 'San José'],
  ['Rafael Perazza', 'San José'],
  ['Raigon', 'San José'],
  ['Playa Pascual', 'San José'],
  ['Punta San Gregorio', 'San José'],
  ['Autodromo', 'San José'],
  ['Boca del Cufre', 'San José'],
  ['Colonia Vicente Pere', 'San José'],
  ['Ecilda Paullier', 'San José'],
  ['Juan Soler', 'San José'],
  ['Mundo Azul', 'San José'],
  ['Rincon de Albano', 'San José'],
  ['San Gregorio', 'San José'],
  ['Scavino', 'San José'],
  ['Puntas de Cañada gde', 'San José'],
  ['25 de Agosto', 'San José'],
  ['Punta del Tigre', 'San José'],
  ['Rodriguez', 'San José'],
  ['Tropa Vieja', 'San José'],
  ['Carreta Quemada', 'San José'],
  ['Cuchilla de Vichader', 'San José'],
  ['Rincon de la Bolsa', 'San José'],
  ['Colonia Etchepare', 'San José'],
  ['CAPURRO', 'San José'],
  ['ITUZAINGO', 'San José'],
  ['RINCON DE LA TORRE', 'San José'],
  ['VILLA MARIA', 'San José'],
  ['PUNTAS DE VALDES', 'San José'],
  ['GONZALEZ', 'San José'],
  ['RAPETTI', 'San José'],
  ['VILLA RODRIGUEZ', 'San José'],
  ['Trinidad', 'Flores'],
  ['Arroyo Malo', 'Flores'],
  ['Juan Jose Castro', 'Flores'],
  ['Los Puentes', 'Flores'],
  ['Paso de Lugo', 'Flores'],
  ['Puntas del Sauce', 'Flores'],
  ['Costas de San Jose', 'Flores'],
  ['Ahogados', 'Flores'],
  ['Cerro Colorado', 'Flores'],
  ['Los Arrajanes', 'Flores'],
  ['Manantiales', 'Flores'],
  ['Paso Hondo', 'Flores'],
  ['Andresito', 'Flores'],
  ['Arenal Chico', 'Flores'],
  ['Ismael Cortinas', 'Flores'],
  ['Los Cerros', 'Flores'],
  ['Marincho', 'Flores'],
  ['Puntas de Cebollati', 'Flores'],
  ['Rincon del Palacio', 'Flores'],
  ['Florida', 'Florida'],
  ['Cardal', 'Florida'],
  ['Reboledo', 'Florida'],
  ['Colonia 33 Orientale', 'Florida'],
  ['Goñi', 'Florida'],
  ['La Cruz', 'Florida'],
  ['Mendoza Chico', 'Florida'],
  ['Batlle y Ordoñez', 'Florida'],
  ['Paso Castro', 'Florida'],
  ['Puntas de Maciel', 'Florida'],
  ['Sauce del Yi', 'Florida'],
  ['Villa Vieja', 'Florida'],
  ['Sarandi Grande', 'Florida'],
  ['Est. Capilla del Sau', 'Florida'],
  ['Est. Talita', 'Florida'],
  ['Est. Dr. Alejandro G', 'Florida'],
  ['Arroyo de la Virgen', 'Florida'],
  ['Casupa', 'Florida'],
  ['Cerro Colorado', 'Florida'],
  ['Chamizo', 'Florida'],
  ['Illescas', 'Florida'],
  ['Mansavillagra', 'Florida'],
  ['Montecoral', 'Florida'],
  ['Palermo', 'Florida'],
  ['Pintado', 'Florida'],
  ['San Gabriel', 'Florida'],
  ['25 de Agosto', 'Florida'],
  ['Est. Ptas. de Maciel', 'Florida'],
  ['Est. Sta. Teresa', 'Florida'],
  ['Capilla del Sauce', 'Florida'],
  ['Valentines', 'Florida'],
  ['Est. Co. Colorado', 'Florida'],
  ['Berrondo', 'Florida'],
  ['Fray Marcos', 'Florida'],
  ['Cerro Chato', 'Florida'],
  ['Chamizo Chico', 'Florida'],
  ['Independencia', 'Florida'],
  ['Mendoza', 'Florida'],
  ['Nico Perez', 'Florida'],
  ['Paraje Sta. Teresa', 'Florida'],
  ['Polanco del Yi', 'Florida'],
  // ['Sarandi Grande', 'Florida'],
  ['25 de Mayo', 'Florida'],
  ['Est. Sarandi Gde.', 'Florida'],
  ['Rodriguez', 'Florida'],
  ['Est. Hernandarias', 'Florida'],
  ['Alejandro Gallinal', 'Florida'],
  ['Est. Nico Perez', 'Florida'],
  ['MENDOZA GRANDE', 'Florida'],
  ['LOS ARRAYANES', 'Florida'],
  ['PUNTAS CEBOLLATI', 'Florida'],
  ['Colonia del Sacramen', 'Colonia'],
  ['Colonia Suiza', 'Colonia'],
  ['Barkero', 'Colonia'],
  ['Campamento Artigas', 'Colonia'],
  ['Juan Gonzalez', 'Colonia'],
  ['Colonia Española', 'Colonia'],
  ['Cufre', 'Colonia'],
  ['Cardona', 'Colonia'],
  ['Colonia Cosmopolita', 'Colonia'],
  ['Manantiales', 'Colonia'],
  ['Playa Fomento', 'Colonia'],
  ['Rosario', 'Colonia'],
  ['Nueva Helvecia', 'Colonia'],
  ['Santa Ana', 'Colonia'],
  ['Viboras', 'Colonia'],
  ['Martin Chico', 'Colonia'],
  ['Punta Francesa', 'Colonia'],
  ['Real de San Carlos', 'Colonia'],
  ['Agraciada', 'Colonia'],
  ['Boca del Rosario', 'Colonia'],
  ['Campana', 'Colonia'],
  ['Cerro', 'Colonia'],
  ['Colonia Miguelete', 'Colonia'],
  ['Estanzuela', 'Colonia'],
  ['Ismael Cortinas', 'Colonia'],
  ['Minuano', 'Colonia'],
  ['Nueva Palmira', 'Colonia'],
  ['Puerto Rosario', 'Colonia'],
  ['Colonia Piamontesa', 'Colonia'],
  ['San Juan', 'Colonia'],
  ['Tarariras', 'Colonia'],
  ['Colonia Estrella', 'Colonia'],
  ['Los Cerros de San Ju', 'Colonia'],
  ['El Caño', 'Colonia'],
  ['Mal Abrigo', 'Colonia'],
  ['Cerro de las Armas', 'Colonia'],
  ['Semillero', 'Colonia'],
  ['Artilleros', 'Colonia'],
  ['Buena Hora', 'Colonia'],
  ['Carmelo', 'Colonia'],
  ['Colonia Arrue', 'Colonia'],
  ['Conchillas', 'Colonia'],
  ['Florencio Sanchez', 'Colonia'],
  ['Juan Lacaze', 'Colonia'],
  ['La Horqueta', 'Colonia'],
  ['Ombues de lavalle', 'Colonia'],
  ['Riachuelo', 'Colonia'],
  ['Colonia Valdense', 'Colonia'],
  ['San Pedro', 'Colonia'],
  ['Tres Esquinas', 'Colonia'],
  ['Punta Piedras', 'Colonia'],
  ['Punta Pereyra', 'Colonia'],
  ['Punta Hornos', 'Colonia'],
  ['Punta Santa Rita', 'Colonia'],
  ['Punta de los Patos', 'Colonia'],
  ['Punta Artilleros', 'Colonia'],
  ['Punta del Rosario', 'Colonia'],
  ['LA PAZ', 'Colonia'],
  ['LOS PINOS', 'Colonia'],
  ['MIGUELETE', 'Colonia'],
  ['BLANCARENA', 'Colonia'],
  ['Mercedes', 'Soriano'],
  ['Soriano', 'Soriano'],
  ['Bequelo', 'Soriano'],
  ['Cañada Paraguaya', 'Soriano'],
  ['Cololo', 'Soriano'],
  ['Coquimbo', 'Soriano'],
  ['Egaña', 'Soriano'],
  ['J. Enrique Rodo', 'Soriano'],
  ['Monzon', 'Soriano'],
  ['Palo Solo', 'Soriano'],
  ['Risso', 'Soriano'],
  ['Villa Darwin', 'Soriano'],
  ['Rincon del Cololo', 'Soriano'],
  ['Est. Grito de Asenci', 'Soriano'],
  ['Agraciada', 'Soriano'],
  ['Bizcocho', 'Soriano'],
  ['Cardona', 'Soriano'],
  ['Colonia Larrañaga', 'Soriano'],
  ['Dolores', 'Soriano'],
  ['Geymonat', 'Soriano'],
  ['Juan J. Jackson', 'Soriano'],
  ['Palmar', 'Soriano'],
  ['Paso de las Piedras', 'Soriano'],
  ['San Martin', 'Soriano'],
  ['Suarez', 'Soriano'],
  ['Villa Soriano', 'Soriano'],
  ['Castillos', 'Soriano'],
  ['Azotea de Vera', 'Soriano'],
  ['Cañada Nieto', 'Soriano'],
  ['Florencio Sanchez', 'Soriano'],
  ['Concordia', 'Soriano'],
  ['Duraznito', 'Soriano'],
  ['Ismael Cortinas', 'Soriano'],
  ['La Laguna', 'Soriano'],
  ['Palmitas', 'Soriano'],
  ['Perdido', 'Soriano'],
  ['Santa Catalina', 'Soriano'],
  ['Uturbey', 'Soriano'],
  ['Rincon de Cololo', 'Soriano'],
  ['Cuchilla del Perdido', 'Soriano'],
  ['Paysandú', 'Paysandú'],
  ['Quebracho', 'Paysandú'],
  ['Casablanca', 'Paysandú'],
  ['Chapicuy', 'Paysandú'],
  ['Gualeguay', 'Paysandú'],
  ['Las Delicias', 'Paysandú'],
  ['Gorgoroso', 'Paysandú'],
  ['Piedras Coloradas', 'Paysandú'],
  ['Pueblo Morato', 'Paysandú'],
  ['Termas de Guaviyu', 'Paysandú'],
  ['Valdez', 'Paysandú'],
  ['La Tentacion', 'Paysandú'],
  ['Federacion', 'Paysandú'],
  ['Esperanza', 'Paysandú'],
  ['Algorta', 'Paysandú'],
  ['Constancia', 'Paysandú'],
  ['Dayman', 'Paysandú'],
  ['Guichon', 'Paysandú'],
  ['Merinos', 'Paysandú'],
  ['Pandule', 'Paysandú'],
  ['Piñera', 'Paysandú'],
  ['Pueblo Porvenir', 'Paysandú'],
  ['Queguay', 'Paysandú'],
  ['Tiatucura', 'Paysandú'],
  ['Piedra Sola', 'Paysandú'],
  ['San Felix', 'Paysandú'],
  ['Cañada del Pueblo', 'Paysandú'],
  ['Arroyo Malo', 'Paysandú'],
  ['Cuchilla de San Jose', 'Paysandú'],
  ['Est. Porvenir', 'Paysandú'],
  ['Kilometro 171', 'Paysandú'],
  ['Molles Esperanza', 'Paysandú'],
  ['Parada Esperanza', 'Paysandú'],
  ['Pueblo Gallinal', 'Paysandú'],
  ['Puntas de Gualeguay', 'Paysandú'],
  ['Queguay Chico', 'Paysandú'],
  ['Tres Arboles', 'Paysandú'],
  ['Tambores', 'Paysandú'],
  ['Lorenzo Geyres', 'Paysandú'],
  ['El Eucaliptus', 'Paysandú'],
  ['Arbolito', 'Paysandú'],
  ['BEISSO', 'Paysandú'],
  ['CERRO CHATO', 'Paysandú'],
  ['SAN JAVIER', 'Paysandú'],
  ['QUEGUAYAR', 'Paysandú'],
  ['Fray Bentos', 'Río Negro'],
  ['Colonia Kennedy', 'Río Negro'],
  ['Las Flores', 'Río Negro'],
  ['Navarro', 'Río Negro'],
  ['Paraje Sauce-Sanchez', 'Río Negro'],
  ['Paso de la Laguna', 'Río Negro'],
  ['Porrua', 'Río Negro'],
  ['Sanchez', 'Río Negro'],
  ['Uleste', 'Río Negro'],
  ['Merinos', 'Río Negro'],
  ['Las Cañas', 'Río Negro'],
  ['Francia', 'Río Negro'],
  ['Los Mellizos', 'Río Negro'],
  ['Nuevo Berlin', 'Río Negro'],
  ['Pasaje Tres Bocas', 'Río Negro'],
  ['Paso Leopoldo', 'Río Negro'],
  ['Porton Haedo', 'Río Negro'],
  ['Sarandi de Navarro', 'Río Negro'],
  ['Young', 'Río Negro'],
  ['Cañitas', 'Río Negro'],
  ['Grecco', 'Río Negro'],
  ['Menafra', 'Río Negro'],
  ['Palma', 'Río Negro'],
  ['Paso de la Cruz', 'Río Negro'],
  ['Pilares', 'Río Negro'],
  ['San Javier', 'Río Negro'],
  ['Tres Bocas', 'Río Negro'],
  ['Algorta', 'Río Negro'],
  ['Rolon', 'Río Negro'],
  ['BELLACO', 'Río Negro'],
  ['Salto', 'Salto'],
  ['Colonia Itapebi', 'Salto'],
  ['Constitucion', 'Salto'],
  ['Laureles', 'Salto'],
  ['Pueblo Mataojito', 'Salto'],
  ['San Antonio', 'Salto'],
  ['Termas del Arapey', 'Salto'],
  ['Saucedo', 'Salto'],
  ['Ferreira', 'Salto'],
  ['Cayetano', 'Salto'],
  ['Arenitas Blancas', 'Salto'],
  ['Belen', 'Salto'],
  ['Colonia Rubio', 'Salto'],
  ['Cuchilla de Guaviyu', 'Salto'],
  ['Palomas', 'Salto'],
  ['Puntas de Valentin', 'Salto'],
  ['Sarandi de Arapey', 'Salto'],
  ['Valentin', 'Salto'],
  ['Lluveras', 'Salto'],
  ['Itapebi', 'Salto'],
  ['Mataojo', 'Salto'],
  ['Cerro de Vera', 'Salto'],
  ['Colonia Santa Blanca', 'Salto'],
  ['Cuchilla de Salto', 'Salto'],
  ['Pueblo Lavalleja', 'Salto'],
  ['Rincon de Valentin', 'Salto'],
  ['Sarandi del Yacui', 'Salto'],
  ['Estacion Santa Ana', 'Salto'],
  ['Olivera', 'Salto'],
  ['Biassini', 'Salto'],
  ['Albisu', 'Salto'],
  ['Artigas', 'Artigas'],
  ['Brig. Gral Diego Lam', 'Artigas'],
  ['Colonia Aparicio Sar', 'Artigas'],
  ['Javier de Viana', 'Artigas'],
  ['Palma Sola', 'Artigas'],
  ['Pintado Grande', 'Artigas'],
  ['Tomas Gomensoro', 'Artigas'],
  ['Sequeira', 'Artigas'],
  ['Paso del Leon', 'Artigas'],
  ['Baltasar Brum', 'Artigas'],
  ['Bernabe Rivera', 'Artigas'],
  ['Colonia Jose Artigas', 'Artigas'],
  ['Menezes', 'Artigas'],
  ['Paso Farias', 'Artigas'],
  ['Sarandi del Cuaro', 'Artigas'],
  ['Topador', 'Artigas'],
  ['Sarandi de Cuaro', 'Artigas'],
  ['Bella Union', 'Artigas'],
  ['Campamento', 'Artigas'],
  ['Colonia Palma', 'Artigas'],
  ['Mones Quintela', 'Artigas'],
  ['Pueblo Sequeira', 'Artigas'],
  ['Tamandua', 'Artigas'],
  ['Cuaro', 'Artigas'],
  ['BELEN', 'Artigas'],
  ['CALPICA ITACUMBU', 'Artigas'],
  ['Rivera', 'Rivera'],
  ['Amarillo', 'Rivera'],
  ['Cerro Pelado', 'Rivera'],
  ['Lagos del Norte', 'Rivera'],
  ['Masoller', 'Rivera'],
  ['Paso del Ataque', 'Rivera'],
  ['Vichadero', 'Rivera'],
  ['Puntas de Corrales', 'Rivera'],
  ['Caraguata', 'Rivera'],
  ['Abrojal', 'Rivera'],
  ['Arroyo Blanco', 'Rivera'],
  ['La Calera', 'Rivera'],
  ['Las Flores', 'Rivera'],
  ['Minas de Corrales', 'Rivera'],
  ['Tranqueras', 'Rivera'],
  ['Zanja Honda', 'Rivera'],
  ['Cuchilla Mangueras', 'Rivera'],
  ['Coronilla', 'Rivera'],
  ['Aduana de Batovi', 'Rivera'],
  ['Cerrillada', 'Rivera'],
  ['La Puente', 'Rivera'],
  ['Manuel Diaz', 'Rivera'],
  ['Moirones', 'Rivera'],
  ['Tres Puentes', 'Rivera'],
  ['Ataques', 'Rivera'],
  ['Hospital', 'Rivera'],
  ['Melo', 'Cerro Largo'],
  ['Fraile Muerto', 'Cerro Largo'],
  ['Olimar', 'Cerro Largo'],
  ['Placido Rosas', 'Cerro Largo'],
  ['Maria Isabel', 'Cerro Largo'],
  ['Tres Islas', 'Cerro Largo'],
  ['Tupambae', 'Cerro Largo'],
  ['Acegua', 'Cerro Largo'],
  ['Bañado de Medina', 'Cerro Largo'],
  ['Isidro Noblia', 'Cerro Largo'],
  ['Palleros', 'Cerro Largo'],
  ['Pueblo Arevalo', 'Cerro Largo'],
  ['Uruguay', 'Cerro Largo'],
  ['Toledo', 'Cerro Largo'],
  ['Arbolito', 'Cerro Largo'],
  ['Cerro de las Cuentas', 'Cerro Largo'],
  ['Lago Merin', 'Cerro Largo'],
  ['Paso de Centurion', 'Cerro Largo'],
  ['Rio Branco', 'Cerro Largo'],
  ['La Pedrera', 'Cerro Largo'],
  ['Est. Aparicio Saravi', 'Cerro Largo'],
  ['SARANDI BARCELO', 'Cerro Largo'],
  ['Tacuarembó', 'Tacuarembó'],
  ['Paso de los Toros', 'Tacuarembó'],
  ['Batovi', 'Tacuarembó'],
  ['Cuchilla de Caraguat', 'Tacuarembó'],
  ['Curtina', 'Tacuarembó'],
  ['Pampa', 'Tacuarembó'],
  ['Paso de las Toscas', 'Tacuarembó'],
  ['Pueblo Centenario', 'Tacuarembó'],
  ['Peralta', 'Tacuarembó'],
  ['Pueblo Arbolito', 'Tacuarembó'],
  ['San Gregorio de Pola', 'Tacuarembó'],
  ['Zapara', 'Tacuarembó'],
  ['Bañado de Rocha', 'Tacuarembó'],
  ['Pueblo de Arriba', 'Tacuarembó'],
  ['Las Arenas', 'Tacuarembó'],
  ['Pueblo de Barro', 'Tacuarembó'],
  ['Cuchilla de Peralta', 'Tacuarembó'],
  ['Martinote', 'Tacuarembó'],
  ['Achar', 'Tacuarembó'],
  ['Baygorria', 'Tacuarembó'],
  ['Cuchilla de Ramirez', 'Tacuarembó'],
  ['La Hilera', 'Tacuarembó'],
  ['Paraje Arriera', 'Tacuarembó'],
  ['Paso de los Novillos', 'Tacuarembó'],
  ['Paso del Cerro', 'Tacuarembó'],
  ['Piedra Sola', 'Tacuarembó'],
  ['Pueblo Clavijo', 'Tacuarembó'],
  ['Tambores', 'Tacuarembó'],
  ['Paso Ceferino', 'Tacuarembó'],
  ['Quiebra Yugos', 'Tacuarembó'],
  ['Los Vazquez', 'Tacuarembó'],
  ['Larrayos', 'Tacuarembó'],
  ['Blanquillos', 'Tacuarembó'],
  ['Chamberlain', 'Tacuarembó'],
  ['Aldea San Joaquin', 'Tacuarembó'],
  ['Clara', 'Tacuarembó'],
  ['Cuchilla del Ombu', 'Tacuarembó'],
  ['Menendez', 'Tacuarembó'],
  ['Paso Bonilla', 'Tacuarembó'],
  ['Paso Manzangano', 'Tacuarembó'],
  ['Pueblo Ansina', 'Tacuarembó'],
  ['Rincon de Pereyra', 'Tacuarembó'],
  ['Tierras Coloradas', 'Tacuarembó'],
  ['Paso de las Carretas', 'Tacuarembó'],
  ['Los Rosanos', 'Tacuarembó'],
  ['Picada de Cuello', 'Tacuarembó'],
  ['Las Toscas', 'Tacuarembó'],
  ['Cardozo', 'Tacuarembó'],
  ['Rincon del Bonete', 'Tacuarembó'],
  ['CAPON DE LA YERBA', 'Tacuarembó'],
  ['PASO HONDO', 'Tacuarembó'],
  ['VALLE EDEN', 'Tacuarembó'],
  ['LAURELES', 'Tacuarembó'],
  ['LA PEDRERA', 'Tacuarembó'],
  ['PUEBLO HERIBERTO', 'Tacuarembó'],
];

export default localidades;
